import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  enrollmentApi,
  DropEnrollmentRequest,
  RecordGradeRequest,
  CloseGradeRequest,
  EnrollStudentRequest,
} from '../lib/api/enrollment.api';

export function useEnrollment() {
  const queryClient = useQueryClient();

  const enrollStudentMutation = useMutation({
    mutationFn: (data: EnrollStudentRequest) => enrollmentApi.enrollStudent(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['enrollments'] });
      queryClient.invalidateQueries({ queryKey: ['sections'] });
    },
  });

  const dropEnrollmentMutation = useMutation({
    mutationFn: (data: DropEnrollmentRequest) => enrollmentApi.dropEnrollment(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['enrollments'] });
      queryClient.invalidateQueries({ queryKey: ['sections'] }); // spots get freed
    },
  });

  const recordGradeMutation = useMutation({
    mutationFn: (data: RecordGradeRequest) => enrollmentApi.recordGrade(data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['enrollments'] }),
  });

  const closeGradeMutation = useMutation({
    mutationFn: (data: CloseGradeRequest) => enrollmentApi.closeGrade(data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['enrollments'] }),
  });

  return {
    enrollStudent: enrollStudentMutation.mutateAsync,
    isEnrollingStudent: enrollStudentMutation.isPending,

    dropEnrollment: dropEnrollmentMutation.mutateAsync,
    isDroppingEnrollment: dropEnrollmentMutation.isPending,

    recordGrade: recordGradeMutation.mutateAsync,
    isRecordingGrade: recordGradeMutation.isPending,

    closeGrade: closeGradeMutation.mutateAsync,
    isClosingGrade: closeGradeMutation.isPending,
  };
}
